import { Component, Input } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-file-icon',
  standalone: true,
  templateUrl: './file-icon.component.html',
  styleUrls: ['./file-icon.component.scss'],
  imports: [SharedModule],
})
export class FileIconComponent {
  @Input() extension: FileExtension;
  @Input() width = 28;
  @Input() height = 32;

  get iconPath(): string {
    switch (this.extension.toLowerCase()) {
      case 'pdf': {
        return 'assets/images/pictograms/file-pdf.svg';
      }
      case 'memo': {
        return 'assets/images/pictograms/file-memo.svg';
      }
      case 'docx': {
        return 'assets/images/pictograms/docx.svg';
      }
      case 'xlsx': {
        return 'assets/images/pictograms/xlsx.svg';
      }
      case 'folder': {
        return 'assets/images/pictograms/folder.svg';
      }
      case 'mp4': {
        return 'assets/images/pictograms/file-mp4.svg';
      }
      default: {
        return 'assets/images/pictograms/no-image.svg';
      }
    }
  }
}

export type FileExtension =
  | 'pdf'
  | 'memo'
  | 'docx'
  | 'xlsx'
  | 'folder';
